// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-o-nama-js": () => import("./../../../src/pages/o-nama.js" /* webpackChunkName: "component---src-pages-o-nama-js" */),
  "component---src-pages-pravila-privatnosti-js": () => import("./../../../src/pages/pravila-privatnosti.js" /* webpackChunkName: "component---src-pages-pravila-privatnosti-js" */),
  "component---src-templates-usluga-js": () => import("./../../../src/templates/usluga.js" /* webpackChunkName: "component---src-templates-usluga-js" */)
}

